import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  LIBRARY_CATEGORIES_SET_LIST_CATEGORIES,
  LIBRARY_CATEGORIES_SET_OUTLETS,
  LIBRARY_CATEGORIES_SET_CURRENT_PAGE,
  LIBRARY_CATEGORIES_SET_TOTAL_PAGE,
  LIBRARY_CATEGORIES_SET_KEYWORD,
  LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL,
  LIBRARY_CATEGORIES_SET_DELETED_CATEGORY,
  LIBRARY_CATEGORIES_SHOW_DELETE_MODAL,
  LIBRARY_CATEGORIES_HIDE_DELETE_MODAL,
  LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE,
  LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_IS_SUBMITTING_FORM
} from 'actions/library/category/constants'

let initialState = {
  outlets: [],
  categories: [],
  currentPage: null,
  totalPage: null,
  keyword: null,
  categoryDetail: null,
  deletedCategory: null,
  showDeleteModal: false,
  showAssignToItemModal: false,
  assignToItems: {
    items: [],
    currentPage: 0,
    totalPage: 0
  },
  openRightColumn: false,
  isSubmittingForm: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case LIBRARY_CATEGORIES_SET_LIST_CATEGORIES:
      return {...state, categories: payload.categories}
    case LIBRARY_CATEGORIES_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case LIBRARY_CATEGORIES_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case LIBRARY_CATEGORIES_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case LIBRARY_CATEGORIES_SET_KEYWORD:
      return {...state, keyword: payload.keyword}
    case LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL:
      return {...state, categoryDetail: payload.category}
    case LIBRARY_CATEGORIES_SET_DELETED_CATEGORY:
      return {...state, deletedCategory: payload.deletedCategory}
    case LIBRARY_CATEGORIES_SHOW_DELETE_MODAL:
      return {...state, showDeleteModal: true}
    case LIBRARY_CATEGORIES_HIDE_DELETE_MODAL:
      return {...state, showDeleteModal: false}
    case LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL:
      return {...state, showAssignToItemModal: true}
    case LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL:
      return {...state, showAssignToItemModal: false}
    case LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS:
      return {...state, assignToItems: {...state.assignToItems, items: payload.items}}
    case LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE:
      return {...state, assignToItems: {...state.assignToItems, currentPage: payload.currentPage}}
    case LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE:
      return {...state, assignToItems: {...state.assignToItems, totalPage: payload.totalPage}}
    case LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case LIBRARY_CATEGORIES_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/library/category.js